// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 21.0001H21V1.13159L17.0537 3.76245L14.5 1.71948L12 3.71948L9.5 1.71948L6.94629 3.76245L3 1.13159V21.0001ZM17 12H11V10H17V12ZM7 16V14H17V16H7ZM9.00391 10V12.0039H7V10H9.00391Z"}}]};

const CouponFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'coupon-filled',
    ref,
    icon: element,
  },
));

CouponFilledIcon.displayName = 'CouponFilledIcon';

export default CouponFilledIcon;
